import React from 'react';

import './PanelBlock.scss';



const PanelBlock = props => {
  const {
    heading = null,
    postHeading = null,
    actions = [],
    children
  } = props;

  return (
    <div className="parkchirp--panel-block">
      {(heading !== null || actions.length > 0) &&
        <header className="parkchirp--panel-block--header">
          <span className="parkchirp--panel-block--heading">{heading}</span>

          {postHeading &&
            <span className="parkchirp--panel-block--heading-post">{postHeading}</span>
          } 

          <ul className="parkchirp--panel-block--header-actions">
            {actions.map((action, index) => {
              return (
                <li key={index}
                  className="parkchirp--panel-block--header-action">
                  {action}
                </li>
              );
            })}
          </ul>
        </header>
      }
      <div className="parkchirp--panel-block--body">
        {children}
      </div>
    </div>
  );
}
export default PanelBlock;
